import React from 'react';

import withPensionExpertTier from '../../util/pensionExpertTier/withPensionExpertTier';

import NotificationBanner from '../NotificationBanner/NotificationBanner';

const MissingRpOngoingNotification = ({ isPoolExpert, expertRoleTitle }) => {
  return (
    <NotificationBanner
      alertCategory={'Red'}
      alertTitle={
        isPoolExpert
          ? 'Please contact our Pension Experts'
          : `Please contact your dedicated ${expertRoleTitle}`
      }
      expandableAlertDescription={'We are currently not able to show your pension details.'}
      ctaButtonOptions={{
        size: 'medium',
        label: isPoolExpert ? 'Message our Pension Experts' : `Message my ${expertRoleTitle}`,
        to: 'inbox/new-message',
      }}
    />
  );
};

export default withPensionExpertTier(MissingRpOngoingNotification);
